module.exports = __webpack_public_path__ + "static/media/david_batisseur.2fc16bf0.jpg";